const SUPPORT_USERTYPES = [
  'agency-owner',
  'system-admin',
  'internal-admin',
  'internal-staff',
  'divisional-leader',
  'district-leader',
  'regional-leader',
  'career-agent',
  'limited-to-contracting-signature-agent',
  'limited-to-training-signature-agent',
  'signature-agent-in-need-of-pic',
  'signature-agent-complete',
  'premier-agent',
  'division-admin',
  'region-admin',
  'district-admin',
]

export default SUPPORT_USERTYPES
